export default "__VITE_ASSET__BPoERXrS__"